export const locale = {
    lang: 'pt',
    data: {
      'TOOLBAR': {
          'PERFIL': 'O meu perfil' ,
          'INBOX': 'Caixa de entrada',
          'LOGOUT': 'Saída',
          'ADMIN': 'Assinado como:',
          'LOGIN': 'Entrar em: ',
          'GOPROFILE':'Profile',
          'CITIES':{
            '1':'Cidade do México',
            '2':'San salvador',
            '3':'Hong kong',
            '4':'Singapure',
            '5':'Istanbul',
            '6':'Victoria',
            '8':'Cidade do México',
            '11':'São Paulo',
            '14':'Cidade do México',
            '15':'Madrid',
            'IZZI':'Cidade do México',
            'MX':'Cidade do México',
            '19':'Cidade do México',
        },
        'LOGOUT_MODAL': {
          'TEXTO': 'Tem certeza de que deseja sair?',
          'SI': 'Sim',
          'NO': 'Não'
        }
      }
    }
};
